import React from "react";
import { Container, Row, Col, Card, Accordion, Button } from "react-bootstrap";

const Knowledge = () => {
  return (
    <section className="keyzi_content--wrapper">
      <Container>
        <div className="keyzi_content--inner">
          <Row>
            <Col md={12}>
              <Card className="p-4">
                <Row>
                  <Col md={6}>
                    <h4>Knowledge Plus Skill Gives Confidence</h4>
                    <h5>Polishing Up</h5>
                    <p>
                      Refreshing your driving skills and updating your knowledge
                      of new road laws certainly increases driver confidence. It
                      also increases personal safety for a driver and for other
                      road users. Importantly, it gives peace of mind to family
                      members and passengers.
                    </p>
                    <ul>
                      <li>
                        Not driven for a considerable time due to sickness, or
                        loss of license
                      </li>
                      <li>
                        Recognize that road laws and road conditions have
                        changed
                      </li>
                      <li>Want to gain their Manual drivers License</li>
                      <li>
                        Purchase a car that is fitted with new modern technology
                      </li>
                      <li>
                        Going to travel interstate on unfamiliar roads, toll
                        ways, and new cities
                      </li>
                      <li>
                        Relocated from a different area, State, or Territory
                      </li>
                      <li>
                        Senior drivers who recognize physical constraints, feel
                        a need to approach responsible safe driving in a
                        different way.
                      </li>
                    </ul>
                    <p>
                      <strong>Payments - Card Only</strong>
                      <br />
                      (Sorry, No cash payments. No direct bank transfer
                      payments)
                    </p>
                    <Button href="#find-instructor" variant="primary">
                      Book Lessons Now
                    </Button>
                  </Col>
                  <Col md={6}>
                    <h4>Frequently Asked Questions</h4>
                    <Accordion>
                      <Accordion.Item eventKey="0">
                        <Accordion.Header>
                          Who can benefit from refresher lessons?
                        </Accordion.Header>
                        <Accordion.Body>
                          Refresher lessons are beneficial for various
                          drivers, including those who haven't driven for a
                          while, are adjusting to new road laws, want to switch
                          to manual driving, have bought a car with new
                          technology, are planning to drive in unfamiliar
                          areas, have relocated, or are senior drivers looking
                          to adapt their driving style.
                        </Accordion.Body>
                      </Accordion.Item>
                      <Accordion.Item eventKey="1">
                        <Accordion.Header>
                          How long does a refresher course typically take?
                        </Accordion.Header>
                        <Accordion.Body>
                          The duration of a refresher course varies depending
                          on individual needs. It can range from a single
                          lesson to address specific concerns, to a series of
                          lessons for more comprehensive skill development.
                          Your instructor will assess your needs and recommend
                          an appropriate course length.
                        </Accordion.Body>
                      </Accordion.Item>
                      <Accordion.Item eventKey="2">
                        <Accordion.Header>
                          Will refresher lessons help me learn about new road
                          laws?
                        </Accordion.Header>
                        <Accordion.Body>
                          Yes, refresher lessons are an excellent way to update
                          your knowledge of current road laws and regulations.
                          Your instructor will cover recent changes in traffic
                          rules, road signs, and safe driving practices to
                          ensure you're up-to-date with the latest
                          requirements.
                        </Accordion.Body>
                      </Accordion.Item>
                      <Accordion.Item eventKey="3">
                        <Accordion.Header>
                          Can refresher lessons help with driving anxiety?
                        </Accordion.Header>
                        <Accordion.Body>
                          Absolutely. Refresher lessons can significantly boost
                          your confidence behind the wheel. By practicing with
                          a professional instructor in a safe environment, you
                          can address specific concerns, learn coping
                          strategies for stressful driving situations, and
                          gradually build your comfort level on the road.
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
        </div>
      </Container>
    </section>
  );
};

export default Knowledge;
